export default "/images/logo-20.png?1834e64a9d3bbf6f326ce5eaf706765d";